import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  align-items: center;
}

a {
  --link-text: var(--dark-text);

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  font-size: var(--bu-font-size-sm);
}

a:last-child {
    flex-grow: 1;
    flex-shrink: 1;
    pointer-events: none;
  }

a.long {
    min-width: 10ch;
    flex-shrink: 999999;
  }

a.long:last-child {
      flex-shrink: 1;
    }

bu-icon {
  margin-left: 8px;
  margin-right: 8px;
  font-size: 20px;
}
`;
export default styles;
